import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'app'

const getInvoicesState = (state: RootState) => state.common.invoices

export const getInvoicesdata = createSelector(
  getInvoicesState,
  state => state.invoicesData
)

export const getInvoices = createSelector(
  getInvoicesdata,
  invoicesData => invoicesData.invoices
)

export const getLoadingState = createSelector(
  getInvoicesState,
  state => state.loading
)

export const getAreThereNoResults = createSelector(
  getInvoicesState,
  state => state.areThereNoResults
)

export const getActiveInvoice = createSelector(
  getInvoicesState,
  state => state.activeInvoice
)

export const getSendPreTrialPaymentRequestState = createSelector(
  getInvoicesState,
  state => state.sendPreTrialPaymentRequest
)

export const getSendSingleNotificationState = createSelector(
  getInvoicesState,
  state => state.sendSingleNotification
)
